const printButtons = [].slice.call(document.querySelectorAll('[data-print]'));

if (printButtons !== null) {
  printButtons.forEach((button) => {
    // set event listener
    button.addEventListener('click', () => {
      window.print();
    });
  });
}



// WEBPACK FOOTER //
// ./assets/js/components/print.js